<label for="inputtext">{{textField.albumGroupeId}}</label>
<p-dropdown [options]="albumGroupeService.albumGroupeDataList" [(ngModel)]="objChant.albumGroupeId"  [formControl]="control" [itemSize]="10"
  [virtualScroll]="false" [filter]="false" [checkmark]="true" optionValue="code" optionLabel="nom"
  styleClass="w100"  placeholder=" -Select {{textField.albumGroupeId}} -" [loading]="albumGroupeService.loadingAlbumGroupeDataList"
  [style]="{'width':'100%'}" (onChange)="onChangeAlbum()">
  <ng-template let-option  pTemplate="selectedItem">
    <div class="ofa" pTooltip="{{option.code}}-{{option.nom}}" tooltipPosition="bottom">
      <img width="25" [src]="option.bannerPath" class="img-circle" />
      {{option.nom}}
    </div>
  </ng-template>
  <ng-template let-option pTemplate="item">
    <img width="25" [src]="option.bannerPath" class="iimg-circle" />
    <span> {{option.nom}} </span>
  </ng-template>
</p-dropdown>
